import { createUseStyles } from 'react-jss'
import { ThemeDefinition } from '../../../data/types/ThemeDefinition'
import { black, white } from '../../../styles/colors'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles((theme: ThemeDefinition) => ({
  hero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: white,
    position: 'relative'
  },

  image: {
    alignSelf: 'stretch'
  },

  heroData: {
    padding: '0 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '16px'
  },

  title: {
    fontFamily: 'GTWalsheim',
    fontWeight: 600,
    lineHeight: '100%',
    fontSize: '32px'
  },

  copyright: {
    fontFamily: 'GothamRounded',
    fontWeight: 400,
    position: 'absolute',
    padding: '6px',
    fontSize: '6px',
    lineHeight: '6px',
    zIndex: 1
  },

  badge: {
    whiteSpace: 'nowrap',
    padding: '8px',
    borderRadius: '5px',
    backgroundColor: '#FFFFFF1A',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'uppercase',
    display: 'inline-flex',
    fontFamily: 'GothamRounded'
  },

  details: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    lineHeight: '100%',
    fontSize: '14px',
    textTransform: 'uppercase',
    fontFamily: 'GothamRounded',
    fontWeight: 400,
    gap: '8px'
  },

  blurb: {
    fontFamily: 'GTWalsheim',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '100%'
  },

  signInButton: {
    padding: '13px 60px',
    minWidth: '218px',
    boxSizing: 'border-box',
    borderRadius: '4px',
    backgroundColor: theme.primaryColor.default,
    color: black,
    fontSize: '14px',
    lineHeight: '12px',
    textTransform: 'uppercase',
    textDecoration: 'none',

    fontFamily: 'GothamRounded',
    fontWeight: 500,

    '&:hover': {
      backgroundColor: theme.primaryColor.light
    },
    '&:active': {
      backgroundColor: theme.primaryColor.dark
    }
  },

  [MediaQueries.Tablet]: {
    heroData: {
      maxWidth: '600px'
    },
    scrollOrbContainer: {
      bottom: '20px'
    },
    copyright: {
      padding: '8px',
      fontSize: '8px',
      lineHeight: '8px'
    }
  },

  [MediaQueries.LaptopSmall]: {
    heroData: {
      maxWidth: '700px'
    },
    title: {
      fontSize: '40px'
    },
    blurb: {
      fontSize: '18px'
    },
    scrollOrbContainer: {
      bottom: '64px'
    },
    scrollOrb: {
      width: '50px',
      height: '50px'
    },
    copyright: {
      padding: '12px',
      fontSize: '12px',
      lineHeight: '12px'
    }
  },

  [MediaQueries.LaptopLarge]: {
    heroData: {
      maxWidth: '850px'
    },
    scrollOrbContainer: {
      bottom: '90px'
    }
  },

  [MediaQueries.Desktop]: {
    scrollOrbContainer: {
      bottom: '200px'
    },
    scrollOrb: {
      width: '64px',
      height: '64px'
    }
  }
}))

export default useStyles
